// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/demand_group_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/demand_group_service.proto.
 */
export const file_bffuser_v1_demand_group_service: GenFile = /*@__PURE__*/
  fileDesc("CiViZmZ1c2VyL3YxL2RlbWFuZF9ncm91cF9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIj8KGkNoZWNrRGVtYW5kR3JvdXBDc3ZSZXF1ZXN0EiEKC2Nzdl9jb250ZW50GAEgASgMQgy6SAl6BxABGICAgBkiYwobQ2hlY2tEZW1hbmRHcm91cENzdlJlc3BvbnNlEhMKC2NoZWNrX3Rva2VuGAEgASgJEhMKC2dyb3VwX2NvdW50GAIgASgFEhoKEnN1cHBseV9wb2ludF9jb3VudBgDIAEoBSI+ChpBcHBseURlbWFuZEdyb3VwQ3N2UmVxdWVzdBIgCgtjaGVja190b2tlbhgBIAEoCUILgAEBukgFcgOwAQEiXgobQXBwbHlEZW1hbmRHcm91cENzdlJlc3BvbnNlEhsKE2NyZWF0ZWRfZ3JvdXBfY291bnQYASABKAUSIgoaY3JlYXRlZF9zdXBwbHlfcG9pbnRfY291bnQYAiABKAUiGwoZRXhwb3J0RGVtYW5kR3JvdXBzUmVxdWVzdCKcAQoVRXhwb3J0RGVtYW5kR3JvdXBzUm93EhYKDmRlbWFuZF9iZ19jb2RlGAEgASgJEhUKDXJldGFpbGVyX2NvZGUYAiABKAkSEgoKZ3JvdXBfbmFtZRgDIAEoCRIkChxzdXBwbHlfcG9pbnRfc3BlY2lmaWNfbnVtYmVyGAQgASgJEhEKBG5hbWUYBSABKAlIAIgBAUIHCgVfbmFtZSKbAQoaRXhwb3J0RGVtYW5kR3JvdXBzUmVzcG9uc2USLwoEcm93cxgBIAMoCzIhLmJmZnVzZXIudjEuRXhwb3J0RGVtYW5kR3JvdXBzUm93EjgKD2RhdGFfdXBkYXRlZF9hdBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBAUISChBfZGF0YV91cGRhdGVkX2F0IiAKHkdldERlbWFuZEdyb3VwRGlyZWN0b3J5UmVxdWVzdCJyCh9HZXREZW1hbmRHcm91cERpcmVjdG9yeVJlc3BvbnNlEhcKD2ZlYXR1cmVfZW5hYmxlZBgBIAEoCBI2CgdlbnRyaWVzGAIgAygLMiUuYmZmdXNlci52MS5EZW1hbmRHcm91cERpcmVjdG9yeUVudHJ5IucBChlEZW1hbmRHcm91cERpcmVjdG9yeUVudHJ5EhcKD2RlbWFuZF9ncm91cF9pZBgBIAEoCRIjCgRhcmVhGAIgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGUSFgoOZGVtYW5kX2JnX2NvZGUYAyABKAkSFQoNcmV0YWlsZXJfY29kZRgEIAEoCRIaCg1yZXRhaWxlcl9uYW1lGAUgASgJSACIAQESEgoKZ3JvdXBfbmFtZRgGIAEoCRIbChNhY3RpdmVfbWVtYmVyX2NvdW50GAcgASgFQhAKDl9yZXRhaWxlcl9uYW1lIkIKHUxpc3REZW1hbmRHcm91cE1lbWJlcnNSZXF1ZXN0EiEKD2RlbWFuZF9ncm91cF9pZBgBIAEoCUIIukgFcgOwAQEiaQoeTGlzdERlbWFuZEdyb3VwTWVtYmVyc1Jlc3BvbnNlEhcKD2ZlYXR1cmVfZW5hYmxlZBgBIAEoCBIuCgdtZW1iZXJzGAIgAygLMh0uYmZmdXNlci52MS5EZW1hbmRHcm91cE1lbWJlciJVChFEZW1hbmRHcm91cE1lbWJlchIkChxzdXBwbHlfcG9pbnRfc3BlY2lmaWNfbnVtYmVyGAEgASgJEhEKBG5hbWUYAiABKAlIAIgBAUIHCgVfbmFtZTK4BAoSRGVtYW5kR3JvdXBTZXJ2aWNlEmgKE0NoZWNrRGVtYW5kR3JvdXBDc3YSJi5iZmZ1c2VyLnYxLkNoZWNrRGVtYW5kR3JvdXBDc3ZSZXF1ZXN0GicuYmZmdXNlci52MS5DaGVja0RlbWFuZEdyb3VwQ3N2UmVzcG9uc2UiABJoChNBcHBseURlbWFuZEdyb3VwQ3N2EiYuYmZmdXNlci52MS5BcHBseURlbWFuZEdyb3VwQ3N2UmVxdWVzdBonLmJmZnVzZXIudjEuQXBwbHlEZW1hbmRHcm91cENzdlJlc3BvbnNlIgASZQoSRXhwb3J0RGVtYW5kR3JvdXBzEiUuYmZmdXNlci52MS5FeHBvcnREZW1hbmRHcm91cHNSZXF1ZXN0GiYuYmZmdXNlci52MS5FeHBvcnREZW1hbmRHcm91cHNSZXNwb25zZSIAEnQKF0dldERlbWFuZEdyb3VwRGlyZWN0b3J5EiouYmZmdXNlci52MS5HZXREZW1hbmRHcm91cERpcmVjdG9yeVJlcXVlc3QaKy5iZmZ1c2VyLnYxLkdldERlbWFuZEdyb3VwRGlyZWN0b3J5UmVzcG9uc2UiABJxChZMaXN0RGVtYW5kR3JvdXBNZW1iZXJzEikuYmZmdXNlci52MS5MaXN0RGVtYW5kR3JvdXBNZW1iZXJzUmVxdWVzdBoqLmJmZnVzZXIudjEuTGlzdERlbWFuZEdyb3VwTWVtYmVyc1Jlc3BvbnNlIgBCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_area, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * @generated from message bffuser.v1.CheckDemandGroupCsvRequest
 */
export type CheckDemandGroupCsvRequest = Message<"bffuser.v1.CheckDemandGroupCsvRequest"> & {
  /**
   * CSV ファイルの生バイト列 (UTF-8 BOM / UTF-8 / Shift_JIS)。上限 50 MB。
   *
   * @generated from field: bytes csv_content = 1;
   */
  csvContent: Uint8Array;
};

/**
 * Describes the message bffuser.v1.CheckDemandGroupCsvRequest.
 * Use `create(CheckDemandGroupCsvRequestSchema)` to create a new message.
 */
export const CheckDemandGroupCsvRequestSchema: GenMessage<CheckDemandGroupCsvRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 0);

/**
 * @generated from message bffuser.v1.CheckDemandGroupCsvResponse
 */
export type CheckDemandGroupCsvResponse = Message<"bffuser.v1.CheckDemandGroupCsvResponse"> & {
  /**
   * 引換券 (10 分有効)。 ApplyDemandGroupCsv に渡す。
   *
   * @generated from field: string check_token = 1;
   */
  checkToken: string;

  /**
   * CSV に含まれるグループ数 (識別キーの distinct 数)。 既存グループを含むか
   * どうかはこの段では判定しない (差分判定は後続 slice) ため、 「登録される数」
   * ではなく「CSV 上の数」である点に注意。
   *
   * @generated from field: int32 group_count = 2;
   */
  groupCount: number;

  /**
   * CSV の所属行数。
   *
   * @generated from field: int32 supply_point_count = 3;
   */
  supplyPointCount: number;
};

/**
 * Describes the message bffuser.v1.CheckDemandGroupCsvResponse.
 * Use `create(CheckDemandGroupCsvResponseSchema)` to create a new message.
 */
export const CheckDemandGroupCsvResponseSchema: GenMessage<CheckDemandGroupCsvResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 1);

/**
 * @generated from message bffuser.v1.ApplyDemandGroupCsvRequest
 */
export type ApplyDemandGroupCsvRequest = Message<"bffuser.v1.ApplyDemandGroupCsvRequest"> & {
  /**
   * @generated from field: string check_token = 1;
   */
  checkToken: string;
};

/**
 * Describes the message bffuser.v1.ApplyDemandGroupCsvRequest.
 * Use `create(ApplyDemandGroupCsvRequestSchema)` to create a new message.
 */
export const ApplyDemandGroupCsvRequestSchema: GenMessage<ApplyDemandGroupCsvRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 2);

/**
 * @generated from message bffuser.v1.ApplyDemandGroupCsvResponse
 */
export type ApplyDemandGroupCsvResponse = Message<"bffuser.v1.ApplyDemandGroupCsvResponse"> & {
  /**
   * 実際に作成したグループ数。 既存グループへの所属追加ではグループは作られ
   * ないため、 CheckDemandGroupCsvResponse.group_count より小さくなりうる。
   *
   * @generated from field: int32 created_group_count = 1;
   */
  createdGroupCount: number;

  /**
   * 登録した所属行数。
   *
   * @generated from field: int32 created_supply_point_count = 2;
   */
  createdSupplyPointCount: number;
};

/**
 * Describes the message bffuser.v1.ApplyDemandGroupCsvResponse.
 * Use `create(ApplyDemandGroupCsvResponseSchema)` to create a new message.
 */
export const ApplyDemandGroupCsvResponseSchema: GenMessage<ApplyDemandGroupCsvResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 3);

/**
 * 絞り込み条件を持たない (= 全件エクスポートが本 RPC の契約)。
 *
 * @generated from message bffuser.v1.ExportDemandGroupsRequest
 */
export type ExportDemandGroupsRequest = Message<"bffuser.v1.ExportDemandGroupsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ExportDemandGroupsRequest.
 * Use `create(ExportDemandGroupsRequestSchema)` to create a new message.
 */
export const ExportDemandGroupsRequestSchema: GenMessage<ExportDemandGroupsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 4);

/**
 * ExportDemandGroupsRow is one CSV row (= 1 供給地点の所属レコード). Mirrors
 * internalapi.v1.ExportDemandGroupsRow。
 *
 * @generated from message bffuser.v1.ExportDemandGroupsRow
 */
export type ExportDemandGroupsRow = Message<"bffuser.v1.ExportDemandGroupsRow"> & {
  /**
   * @generated from field: string demand_bg_code = 1;
   */
  demandBgCode: string;

  /**
   * @generated from field: string retailer_code = 2;
   */
  retailerCode: string;

  /**
   * @generated from field: string group_name = 3;
   */
  groupName: string;

  /**
   * @generated from field: string supply_point_specific_number = 4;
   */
  supplyPointSpecificNumber: string;

  /**
   * 供給地点のメモ (任意)。未設定 = CSV の空セル。
   *
   * @generated from field: optional string name = 5;
   */
  name?: string;
};

/**
 * Describes the message bffuser.v1.ExportDemandGroupsRow.
 * Use `create(ExportDemandGroupsRowSchema)` to create a new message.
 */
export const ExportDemandGroupsRowSchema: GenMessage<ExportDemandGroupsRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 5);

/**
 * @generated from message bffuser.v1.ExportDemandGroupsResponse
 */
export type ExportDemandGroupsResponse = Message<"bffuser.v1.ExportDemandGroupsResponse"> & {
  /**
   * 論理削除されていない所属全行。順序は
   * (需要BGコード, 小売事業者コード, グループ名, 供給地点特定番号) の昇順で決定的。
   *
   * @generated from field: repeated bffuser.v1.ExportDemandGroupsRow rows = 1;
   */
  rows: ExportDemandGroupsRow[];

  /**
   * 出力対象の最終更新時刻 (= 全行の updated_at の最大値)。ダウンロード確認
   * モーダルの「基準時点」に表示する (uploads/common.md AC-DUC-032)。
   * 0 件のときは未設定。
   *
   * @generated from field: optional google.protobuf.Timestamp data_updated_at = 2;
   */
  dataUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.ExportDemandGroupsResponse.
 * Use `create(ExportDemandGroupsResponseSchema)` to create a new message.
 */
export const ExportDemandGroupsResponseSchema: GenMessage<ExportDemandGroupsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 6);

/**
 * @generated from message bffuser.v1.GetDemandGroupDirectoryRequest
 */
export type GetDemandGroupDirectoryRequest = Message<"bffuser.v1.GetDemandGroupDirectoryRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetDemandGroupDirectoryRequest.
 * Use `create(GetDemandGroupDirectoryRequestSchema)` to create a new message.
 */
export const GetDemandGroupDirectoryRequestSchema: GenMessage<GetDemandGroupDirectoryRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 7);

/**
 * @generated from message bffuser.v1.GetDemandGroupDirectoryResponse
 */
export type GetDemandGroupDirectoryResponse = Message<"bffuser.v1.GetDemandGroupDirectoryResponse"> & {
  /**
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;

  /**
   * (area, retailer_code, group_name) 昇順。
   *
   * @generated from field: repeated bffuser.v1.DemandGroupDirectoryEntry entries = 2;
   */
  entries: DemandGroupDirectoryEntry[];
};

/**
 * Describes the message bffuser.v1.GetDemandGroupDirectoryResponse.
 * Use `create(GetDemandGroupDirectoryResponseSchema)` to create a new message.
 */
export const GetDemandGroupDirectoryResponseSchema: GenMessage<GetDemandGroupDirectoryResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 8);

/**
 * @generated from message bffuser.v1.DemandGroupDirectoryEntry
 */
export type DemandGroupDirectoryEntry = Message<"bffuser.v1.DemandGroupDirectoryEntry"> & {
  /**
   * @generated from field: string demand_group_id = 1;
   */
  demandGroupId: string;

  /**
   * demand_bg_code から導出。
   *
   * @generated from field: bfftypes.v1.AreaCode area = 2;
   */
  area: AreaCode;

  /**
   * @generated from field: string demand_bg_code = 3;
   */
  demandBgCode: string;

  /**
   * @generated from field: string retailer_code = 4;
   */
  retailerCode: string;

  /**
   * 事業者マスタに無ければ unset。
   *
   * @generated from field: optional string retailer_name = 5;
   */
  retailerName?: string;

  /**
   * @generated from field: string group_name = 6;
   */
  groupName: string;

  /**
   * 論理削除されていない所属の件数。
   *
   * @generated from field: int32 active_member_count = 7;
   */
  activeMemberCount: number;
};

/**
 * Describes the message bffuser.v1.DemandGroupDirectoryEntry.
 * Use `create(DemandGroupDirectoryEntrySchema)` to create a new message.
 */
export const DemandGroupDirectoryEntrySchema: GenMessage<DemandGroupDirectoryEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 9);

/**
 * @generated from message bffuser.v1.ListDemandGroupMembersRequest
 */
export type ListDemandGroupMembersRequest = Message<"bffuser.v1.ListDemandGroupMembersRequest"> & {
  /**
   * @generated from field: string demand_group_id = 1;
   */
  demandGroupId: string;
};

/**
 * Describes the message bffuser.v1.ListDemandGroupMembersRequest.
 * Use `create(ListDemandGroupMembersRequestSchema)` to create a new message.
 */
export const ListDemandGroupMembersRequestSchema: GenMessage<ListDemandGroupMembersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 10);

/**
 * @generated from message bffuser.v1.ListDemandGroupMembersResponse
 */
export type ListDemandGroupMembersResponse = Message<"bffuser.v1.ListDemandGroupMembersResponse"> & {
  /**
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;

  /**
   * @generated from field: repeated bffuser.v1.DemandGroupMember members = 2;
   */
  members: DemandGroupMember[];
};

/**
 * Describes the message bffuser.v1.ListDemandGroupMembersResponse.
 * Use `create(ListDemandGroupMembersResponseSchema)` to create a new message.
 */
export const ListDemandGroupMembersResponseSchema: GenMessage<ListDemandGroupMembersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 11);

/**
 * @generated from message bffuser.v1.DemandGroupMember
 */
export type DemandGroupMember = Message<"bffuser.v1.DemandGroupMember"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;
};

/**
 * Describes the message bffuser.v1.DemandGroupMember.
 * Use `create(DemandGroupMemberSchema)` to create a new message.
 */
export const DemandGroupMemberSchema: GenMessage<DemandGroupMember> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_group_service, 12);

/**
 * DemandGroupService fronts the 需要グループ CSV アップロード動線 (tracer
 * slice, map #2946 #1) consumed by the frontend upload wizard.
 *
 * The BFF is a pure relay for this service (no business logic): both RPCs
 * are forwarded 1:1 to the backend internalapi DemandGroupService.
 *
 * @generated from service bffuser.v1.DemandGroupService
 */
export const DemandGroupService: GenService<{
  /**
   * CheckDemandGroupCsv parses and validates the CSV, returning a
   * check_token + count summary. organization_id is resolved by the BFF
   * handler from eauth.
   *
   * @generated from rpc bffuser.v1.DemandGroupService.CheckDemandGroupCsv
   */
  checkDemandGroupCsv: {
    methodKind: "unary";
    input: typeof CheckDemandGroupCsvRequestSchema;
    output: typeof CheckDemandGroupCsvResponseSchema;
  },
  /**
   * ApplyDemandGroupCsv exchanges a valid check_token for the actual
   * registration. organization_id is resolved by the BFF handler from
   * eauth.
   *
   * @generated from rpc bffuser.v1.DemandGroupService.ApplyDemandGroupCsv
   */
  applyDemandGroupCsv: {
    methodKind: "unary";
    input: typeof ApplyDemandGroupCsvRequestSchema;
    output: typeof ApplyDemandGroupCsvResponseSchema;
  },
  /**
   * ExportDemandGroups は組織内の論理削除されていない需要グループ所属 (供給地点)
   * 全行を CSV エクスポート用に返す (uploads/common.md §6, AC-DUC-028/029)。
   *
   * @generated from rpc bffuser.v1.DemandGroupService.ExportDemandGroups
   */
  exportDemandGroups: {
    methodKind: "unary";
    input: typeof ExportDemandGroupsRequestSchema;
    output: typeof ExportDemandGroupsResponseSchema;
  },
  /**
   * GetDemandGroupDirectory は需要グループ画面の目録。組織の全グループを返す
   * (エリアは各 entry が持ち、絞り込みは呼び出し側)。
   * feature_enabled=false and nothing else when the flag is off.
   *
   * @generated from rpc bffuser.v1.DemandGroupService.GetDemandGroupDirectory
   */
  getDemandGroupDirectory: {
    methodKind: "unary";
    input: typeof GetDemandGroupDirectoryRequestSchema;
    output: typeof GetDemandGroupDirectoryResponseSchema;
  },
  /**
   * ListDemandGroupMembers は 1 グループの論理削除されていない所属供給地点
   * (supply_point_specific_number 昇順) を返す。
   * feature_enabled=false and nothing else when the flag is off.
   * NOT_FOUND when the demand group does not exist in the organization.
   *
   * @generated from rpc bffuser.v1.DemandGroupService.ListDemandGroupMembers
   */
  listDemandGroupMembers: {
    methodKind: "unary";
    input: typeof ListDemandGroupMembersRequestSchema;
    output: typeof ListDemandGroupMembersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_demand_group_service, 0);

